// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2mlTx","content":"GlobalSearch_content__3t7Nu"};